import { render, staticRenderFns } from "./textDownloadConfig.vue?vue&type=template&id=ef0b9e86&scoped=true"
import script from "./textDownloadConfig.vue?vue&type=script&lang=js"
export * from "./textDownloadConfig.vue?vue&type=script&lang=js"
import style0 from "./textDownloadConfig.vue?vue&type=style&index=0&id=ef0b9e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0b9e86",
  null
  
)

export default component.exports